import React from "react";
import {
  AuthorInfoBase,
  ImageWrapper,
  Image,
  Info,
  Name,
  Suffix,
  Bio,
  AuthorLink,
} from "./author-info.styled";
import { AuthorContentPostFragment } from "../../types/graphql";
import { linkTo } from "../../utils/contentUtils";

interface IAuthorInfoProps {
  authorInfo: AuthorContentPostFragment;
}

const AuthorInfo = (props: IAuthorInfoProps) => {
  const author = props.authorInfo;

  return (
    (author && (
      <AuthorInfoBase>
        {author.image?.url && (
          <ImageWrapper>
            <Image
              src={author.image.url}
              alt={author.image.alt || `${author.name} - Xometry Contributor`}
            />
          </ImageWrapper>
        )}
        <Info>
          {author.name && (
            <Name>
              {author.honorific_prefix && `${author.honorific_prefix} `}
              {author.name}
              {author.honorific_suffix && (
                <Suffix> {author.honorific_suffix}</Suffix>
              )}
            </Name>
          )}
          {author.bio && <Bio>{author.bio}</Bio>}
          {author.author_page && author.author_page?.document && (
            <p>
              <AuthorLink to={linkTo(author.author_page?.document)}>
                Read more articles by {author.name}
              </AuthorLink>
            </p>
          )}
        </Info>
      </AuthorInfoBase>
    )) || <></>
  );
};

export default AuthorInfo;
